import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { FacilityOrderListNewFlowTemplate } from "themes/application/facility-order-new-flow/pages";
import { FacilityOrderListNewFlowViewStore } from "application/facility-order-new-flow/stores";

@setCurrentView(rootStore => new FacilityOrderListNewFlowViewStore(rootStore), "facilityOrderListNewFlowViewStore")
@observer
class FacilityOrderListNewFlow extends React.Component {
    render() {
        return <FacilityOrderListNewFlowTemplate {...this.props} />;
    }
}

export default FacilityOrderListNewFlow;